module.exports = __webpack_public_path__ + "img/icon_borad_on.12fd4baa.svg";